// 银行图标
import { BANK_NO, BANK_ORG } from '@/constants'

export const BANK_ICON_MAP = {
  [BANK_NO.krungsri]: 'card-face-logo-dacheng',

  [BANK_NO.SCB]: 'card-face-logo-huishang'
}

// 银行名称
export const BANK_NAME_MAP = {
  [BANK_NO.krungsri]: {
    th: 'ธนาคารกรุงศรีอยุธยา',
    en: 'Bank of Ayudhya'
  },

  [BANK_NO.SCB]: {
    th: 'ธนาคารไทยพาณิชย์',
    en: 'Siam Commercial Bank'
  }
}

// 银行card 背景
export const BANK_CARD_BG_MAP = {
  [BANK_NO.krungsri]: require('@/assets/bank-image/bg-card-krungsri.png'),

  [BANK_NO.SCB]: require('@/assets/bank-image/bg-card-scb.png')
}

// 银行组织图标
export const BANK_ORG_ICON = {
  [BANK_ORG.master]: 'mastercard',
  [BANK_ORG.jcb]: 'icon-24-JCB',
  [BANK_ORG.visa]: 'visa'
}
